// extracted by mini-css-extract-plugin
module.exports = {"avatarSkill":"AvatarSkill_avatarSkill__2mNRn","intro":"AvatarSkill_intro__2Dqe8"};